
import { BEFORE_SELLING_NFTS, GET_SELLING_NFT } from '../../redux/types';

const initialState = {
    sellingNft: null,
    sellingNftAuth: false
}

export default function sellingNftsRed(state = initialState, action) {
    switch (action.type) {
        case GET_SELLING_NFT:
            return {
                ...state,
                sellingNft: action.payload,
                sellingNftAuth: true
            }
        case BEFORE_SELLING_NFTS:
            return {
                ...state,
                sellingNft: null,
                sellingNftAuth: false
            }
        default:
            return {
                ...state
            }
    }
}
